import React, { useEffect, useState } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
  Divider,
  Tooltip,
} from "@mui/material";
import {
  ExpandMore,
  ExpandLess,
  Clear as ClearIcon,
  ImageOutlined as ImageOutlinedIcon,
  AttachFile as AttachFileIcon,
  ModeEditOutlineRounded as ModeEditOutlineRoundedIcon,
} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { FormatDate, FormatDateShort } from "../../utils/common/DateUtils";
import { useSelector } from "react-redux";
import { CON_DEFAULT_IMG, CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { externalgetApi } from "../../services/externalApis";
import {
  SETTING_API_03,
  SETTING_API_05,
  SETTING_API_09,
} from "../../api/ApiModel";
import {
  FormatCurrencyLKR,
  formatWithCommas,
} from "../../utils/common/CurrencyFormatter";
import ImagePopUp from "../grn/grnpopup/ImagePopUp";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const ViewDataReturnsummaryDetails = ({
  grnItems,
  grnReturns,
  returnedProducts,
  grnreject,
  Returncal,
  grnDocuments,
  grnData,
  grnHeader,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [imagePreviewOpen, setImagePreviewOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [grnDocTypes, setGrnDocTypes] = useState([]);

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, STAFFMAPLOCODE } = SYS_USER.USER_PARAM || {};
  const [expandedId, setExpandedId] = useState(null);

  const handleExpandClick = (id) => {
    setExpandedId((prevId) => (prevId === id ? null : id));
  };

  const grnItemsData = grnItems || [];
  const filteredReturnedProducts = Array.isArray(returnedProducts)
    ? returnedProducts.filter((item) => Number(item?.returnedqty) > 0)
    : [];
  const grnReturnsData = Array.isArray(Returncal)
    ? Returncal.filter((item) => Number(item?.returnedqty) > 0)
    : Returncal || [];
  const grnrejectsData = grnreject || [];

  console.log("grnret...", grnReturnsData);
console.log("qq",grnHeader)
  const handleOpenDocument = (attachment, mimeType = "application/pdf") => {
    const byteCharacters = atob(attachment.bytarr);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    // Optionally revoke the URL after some time
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  };

  useEffect(() => {
    fetchMou();
  }, []);

  const [mouList, setMouList] = useState([]);
  const fetchMou = async () => {
    try {
      const params = {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(SETTING_API_05, "GET", params);
      setMouList(response || []);
    } catch (error) {
      console.error("Error fetching brands:", error);
      setMouList([]);
    }
  };

  const getMouNameByCode = (code) => {
    const mou = mouList.find((b) => b.immeasuringunitcode === code);
    return mou ? mou.immeasuringunit : "No-MOU";
  };
  const isImage = (filename) => {
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(filename);
  };

  const isDocument = (filename) => {
    return /\.(pdf|doc|docx|xls|xlsx)$/i.test(filename);
  };
  const matchedItems = grnItemsData.filter((item) =>
    filteredReturnedProducts.some(
      (returnedItem) => returnedItem.supproductcode === item.supproductcode,
    ),
  );

  console.log("matchedItems", matchedItems);
   console.log("filteredReturnedProducts", filteredReturnedProducts);
   console.log("grnHeader", grnHeader);

   const taxAppleid = grnHeader?.taxtype === "1" ? "Tax Inclusive" : "Tax Exclusive";

  useEffect(() => {
    fetchGrnDocCategory();
  }, []);

  const fetchGrnDocCategory = async () => {
    try {
      const params = { STS: CON_STATUS_ACTIVE };
      const response = await externalgetApi(SETTING_API_09, "GET", params);
      const grnCategory = response.find(
        (cat) => cat.doccatname === "Item-Based Document Types",
      );

      if (grnCategory) {
        fetchGrnDocType(grnCategory.doccatcode);
      }
      console.log("grnCategory", grnCategory);
    } catch (error) {
      console.error("Error fetching GRN document category", error);
    }
  };

  const getDocTypeName = (code) => {
    if (String(code) === "0") return "";

    const found = grnDocTypes.find(
      (doc) => String(doc.doctypecode) === String(code),
    );

    //  Return matched name, or fallback to code or "-"
    return found ? found.doctype : code || "-";
  };

  const fetchGrnDocType = async (docCatCode) => {
    try {
      const params = {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
        DOCCATCODE: docCatCode,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(SETTING_API_03, "GET", params);
      setGrnDocTypes(response); // Save doc types to state
      console.log("grnDocTypes", response);
    } catch (error) {
      console.error("Error fetching GRN document types", error);
    }
  };

  return (
    <>
      <Paper
        variant="outlined"
        sx={{ borderRadius: 2, overflow: "hidden", borderColor: "divider" }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.25,
            bgcolor: "background.paper",
          }}
        >
          {/* Left: title */}
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "0.78rem",
                letterSpacing: "0.09em",

                color: "text.secondary",
              }}
            >
              Return Items
            </Typography>
          </Box>
        </Box>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            boxShadow: "none",
            borderTop: `1px solid`,
            borderColor: "divider",
            borderRadius: 0,
          }}
        >
          <Table sx={{ tableLayout: "fixed" }}>
            <TableHead>
              <TableRow
                sx={{
                  bgcolor: theme.palette.background.default,
                }}
              >
                {/* Expand toggle column */}
                <TableCell
                  sx={{
                    ...styles.grn_table_header_col_first,
                    width: 44,
                    padding: "10px 8px",
                  }}
                />

                {/* Item Details */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 140 }}
                >
                  Item Details
                </TableCell>

                {/* Item Description (Variant) */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 150 }}
                >
                  Item Description (Variant)
                </TableCell>

                {/* Return Quantity */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 100 }}
                >
                  Return Quantity
                </TableCell>

                {/* Unit Cost */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 100 }}
                >
                  Unit Cost
                </TableCell>

                {/* Tax Rate */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 80 }}
                >
                  Tax Rate
                </TableCell>

                {/* Tax Amount Per Unit */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 110 }}
                >
                  Tax Amount Per Unit
                </TableCell>

                {/* Tax Amount */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 100 }}
                >
                  Tax Amount
                </TableCell>

                {/* Total Price */}
                <TableCell
                  sx={{ ...styles.grn_table_header_col_view, width: 100 }}
                >
                  Total Price
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {matchedItems.map((item) => {
                const isExpanded = expandedId === item.supproductcode;

                const returnItem = filteredReturnedProducts.find(
                  (ret) => ret.supproductcode === item.supproductcode,
                );
                const rejectItem = grnrejectsData.find(
                  (ret) => ret.productcode === item.productcode,
                );

                // ── Cost calculations ──────────────────────────────────────────
                let returncostItem = undefined;
                if (Array.isArray(Returncal) && Returncal.length > 0) {
                  const grnReturnItems = Returncal[0]?.grnReturnItems || [];
                  returncostItem = grnReturnItems.find(
                    (ret) =>
                      String(ret.supproductcode) ===
                      String(item.supproductcode),
                  );
                }

                const correctedUnitCostWithoutTax =
                  returncostItem?.unitcostwithouttax != null &&
                  returncostItem.unitcostwithouttax !== ""
                    ? parseFloat(returncostItem.unitcostwithouttax)
                    : item.perunittaxableamount != null &&
                        item.perunittaxableamount !== ""
                      ? parseFloat(item.perunittaxableamount)
                      : item.unitprice
                        ? parseFloat(item.unitprice)
                        : 0;

                const correctedTaxPerUnit =
                  returncostItem?.taxperunit != null &&
                  returncostItem.taxperunit !== ""
                    ? parseFloat(returncostItem.taxperunit)
                    : item.perunittaxvalue
                      ? parseFloat(item.perunittaxvalue)
                      : 0;

                const returnedQty = Number(
                  returnItem?.returnedqty ?? item.returnItem?.returnedqty ?? 0,
                );

                const taxAmount =
                  returnedQty > 0 ? correctedTaxPerUnit * returnedQty : 0;

              
const taxApplied =
  grnHeader?.isvat === "Y"
    ? Number(correctedTaxPerUnit || 0)
    : 0;

const unitCost =
  Number(correctedUnitCostWithoutTax || 0) + taxApplied;

const totalPrice =
  returnedQty > 0
    ? unitCost * Number(returnedQty)
    : 0;

                // ── Attachment parsing for return items ────────────────────────
                let regrnReturnAttachments = [];
                if (returnItem?.docpathjson) {
                  try {
                    regrnReturnAttachments = JSON.parse(returnItem.docpathjson);
                  } catch (e) {
                    console.error("Invalid JSON in returnItem.docpathjson:", e);
                  }
                }
                const base64Attachments1 = item?.returnItem?.attachments || [];
                const reattachmentsToShow =
                  regrnReturnAttachments.length > 0
                    ? regrnReturnAttachments
                    : base64Attachments1;

                // Real attachments (excluding DOCTYPECODE "0")
                const realAttachments =
                  returnItem &&
                  Array.isArray(returnItem.dtoDOCs) &&
                  returnItem.dtoDOCs
                    .filter((att) => att.supproductcode === item.supproductcode)
                    .filter((att) => {
                      if (!att.docpathjson) return true;
                      try {
                        const parsedDocs = JSON.parse(att.docpathjson);
                        return !parsedDocs.some(
                          (doc) => String(doc.DOCTYPECODE) === "0",
                        );
                      } catch (e) {
                        return true;
                      }
                    });

                // Default no-image fallback
                let defaultNoImage = null;
                if (returnItem?.docpathjson) {
                  try {
                    const parsedDocs = JSON.parse(returnItem.docpathjson);
                    defaultNoImage =
                      parsedDocs.find(
                        (doc) =>
                          String(doc.DOCTYPECODE) === "0" &&
                          doc.FILEPATH &&
                          doc.FILEPATH.includes("noimage.png"),
                      ) || null;
                  } catch (e) {}
                }
                if (!defaultNoImage && regrnReturnAttachments.length > 0) {
                  defaultNoImage =
                    regrnReturnAttachments.find(
                      (doc) =>
                        String(doc.DOCTYPECODE) === "0" &&
                        doc.FILEPATH &&
                        doc.FILEPATH.includes("noimage.png"),
                    ) || null;
                }

                // ── Attachment renderer ────────────────────────────────────────
                const renderAttachments = () => {
                  if (realAttachments && realAttachments.length > 0) {
                    return realAttachments.map((attachment, index) => (
                      <Box
                        key={index}
                        display="flex"
                        alignItems="center"
                        gap="4px"
                        mb="4px"
                      >
                        {isImage(
                          attachment?.filename ||
                            attachment?.FILENAME ||
                            attachment?.FILEPATH,
                        ) ? (
                          <Tooltip
                            title={attachment?.filename || attachment?.FILENAME}
                            placement="top"
                          >
                            <img
                              src={
                                attachment?.fileUrl ||
                                (attachment?.docpathjson &&
                                  `data:image/png;base64,${attachment.docpathjson}`) ||
                                attachment?.FILEPATH
                              }
                              alt="File"
                              style={{
                                width: 16,
                                height: 16,
                                objectFit: "cover",
                                cursor: "pointer",
                                borderRadius: 2,
                              }}
                              onClick={() => {
                                setSelectedImage({
                                  url:
                                    attachment?.fileUrl ||
                                    (attachment?.docpathjson &&
                                      `data:image/png;base64,${attachment.docpathjson}`) ||
                                    attachment?.FILEPATH,
                                  name: attachment?.FILENAME || "Image",
                                  description: attachment?.REMARK || "",
                                });
                                setImagePreviewOpen(true);
                              }}
                            />
                          </Tooltip>
                        ) : (
                          <InsertDriveFileIcon
                            onClick={() => {
                              setSelectedImage({
                                url:
                                  attachment?.fileUrl ||
                                  (attachment?.docpathjson &&
                                    `data:image/png;base64,${attachment.docpathjson}`) ||
                                  attachment?.FILEPATH,
                                name: attachment?.FILENAME || "File",
                                description: attachment?.REMARK || "",
                              });
                              setImagePreviewOpen(true);
                            }}
                            style={{ width: 16, height: 16, cursor: "pointer" }}
                          />
                        )}
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: theme.palette.primary.main,
                            cursor: "pointer",
                            "&:hover": { textDecoration: "underline" },
                          }}
                          onClick={() => {
                            setSelectedImage({
                              url:
                                attachment?.fileUrl ||
                                (attachment?.docpathjson &&
                                  `data:image/png;base64,${attachment.docpathjson}`) ||
                                attachment?.FILEPATH,
                              name: attachment?.FILENAME || "File",
                              description: attachment?.REMARK || "",
                            });
                            setImagePreviewOpen(true);
                          }}
                        >
                          {/* {attachment?.FILENAME || attachment?.filename || "View"} */}
                        </Typography>
                      </Box>
                    ));
                  }

                  if (defaultNoImage) {
                    return (
                      <Tooltip title="No attachment" placement="top">
                        <img
                          src={defaultNoImage.FILEPATH}
                          alt="No attachment"
                          style={{ width: 20, height: 20, objectFit: "cover" }}
                        />
                      </Tooltip>
                    );
                  }

                  return (
                    <Tooltip title="No attachment" placement="top">
                      <img
                        src={CON_DEFAULT_IMG}
                        alt="No attachment"
                        style={{ width: 20, height: 20, objectFit: "cover" }}
                      />
                    </Tooltip>
                  );
                };

                return (
                  <React.Fragment key={item.supproductcode}>
                    {/* ── Main data row ──────────────────────────────────────── */}
                    <TableRow
                      sx={{
                        backgroundColor: isExpanded
                          ? "background.paper"
                          : "inherit",
                        "&:hover": {
                          backgroundColor: "action.hover",
                        },
                        borderColor: "divider",
                      }}
                    >
                      {/* Expand toggle */}
                      <TableCell sx={{ px: 1, py: 1, textAlign: "center" }}>
                        <IconButton
                          size="small"
                          onClick={() => handleExpandClick(item.supproductcode)}
                        >
                          {isExpanded ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                      </TableCell>

                      {/* Item Details */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography
                          sx={{ ...styles.grn_table_row, fontWeight: 500 }}
                        >
                          {item.productname || "-"}
                        </Typography>
                        <Typography sx={styles.grn_table_row_title}>
                          Item Code: {item.productcode || "-"}
                        </Typography>
                      </TableCell>

                      {/* Item Description (Variant) */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography
                          sx={{
                            ...styles.grn_table_row,
                            color: "text.secondary",
                          }}
                        >
                          {item.variantname || item.itemdescription || "-"}
                        </Typography>
                      </TableCell>

                      {/* Return Quantity */}
                      <TableCell sx={styles.common_cell_style_2}>
                        {returnedQty > 0 ? (
                          <Typography sx={styles.grn_table_row}>
                            {returnedQty}
                          </Typography>
                        ) : (
                          <Typography sx={styles.grn_table_row}>-</Typography>
                        )}
                      </TableCell>

                      {/* Unit Cost */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography sx={styles.grn_table_row}>
                          {FormatCurrencyLKR(correctedUnitCostWithoutTax || 0)}
                        </Typography>
                      </TableCell>

                      {/* Tax Rate */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography sx={styles.grn_table_row}>
                          {item.taxrate || 0}%
                        </Typography>
                      </TableCell>

                      {/* Tax Amount Per Unit */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography sx={styles.grn_table_row}>
                          {FormatCurrencyLKR(correctedTaxPerUnit)}
                        </Typography>
                      </TableCell>

                      {/* Tax Amount */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography sx={styles.grn_table_row}>
                          {returnedQty > 0 ? FormatCurrencyLKR(taxAmount) : "-"}
                        </Typography>
                      </TableCell>

                      {/* Total Price */}
                      <TableCell sx={styles.common_cell_style_2}>
                        <Typography
                          sx={{
                            ...styles.grn_table_row,
                          }}
                        >
                          {returnedQty > 0
                            ? FormatCurrencyLKR(totalPrice)
                            : "-"}
                        </Typography>
                      </TableCell>
                    </TableRow>

                    {/* ── Expanded "Additional Details" row ─────────────────── */}
                    <TableRow>
                      <TableCell
                        colSpan={9}
                        sx={{
                          p: 0,
                          borderBottom: `1px solid`,
                          borderColor: "divider",
                          bgcolor: theme.palette.background.default,
                        }}
                      >
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ p: 2 }}>
                            {/* Section header */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                mb: 1.5,
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "0.72rem",
                                  fontWeight: 700,
                                  letterSpacing: "0.08em",

                                  color: "text.secondary",
                                }}
                              >
                                Additional Details
                              </Typography>
                            </Box>

                            {/* Detail cells */}
                            <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                              {/* UOM */}
                              <Grid
                                item
                                size={{ xs: 12, sm: 4, md: 4 }}
                                sx={{
                                  border: `1px solid`,
                                  borderColor: "divider",
                                  borderRadius: 1.5,
                                  p: 1.25,
                                  bgcolor: "background.paper",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "text.secondary",
                                    mb: 0.5,

                                    letterSpacing: "0.05em",
                                  }}
                                >
                                  UOM
                                </Typography>
                                <Typography
                                  sx={{ fontSize: "13px", fontWeight: 500 }}
                                >
                                  {item?.immeasuringunit ||
                                    getMouNameByCode(
                                      item?.immeasuringunitcode,
                                    ) ||
                                    "-"}
                                </Typography>
                              </Grid>

                              {/* Reason */}
                              <Grid
                                item
                                size={{ xs: 12, sm: 4, md: 4 }}
                                sx={{
                                  border: `1px solid`,
                                  borderColor: "divider",
                                  borderRadius: 1.5,
                                  p: 1.25,
                                  bgcolor: "background.paper",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "text.secondary",
                                    mb: 0.5,

                                    letterSpacing: "0.05em",
                                  }}
                                >
                                  Reason
                                </Typography>
                                {returnItem?.reason ||
                                returnItem?.descrip ||
                                item.returnItem?.descrip ? (
                                  <Box sx={{}}>
                                    {returnItem?.reason ||
                                      returnItem?.descrip ||
                                      item.returnItem?.descrip}
                                  </Box>
                                ) : (
                                  <Typography sx={{ fontSize: "13px" }}>
                                    -
                                  </Typography>
                                )}
                              </Grid>
                              <Grid
                                item
                                size={{ xs: 12, sm: 4, md: 4 }}
                                sx={{
                                  border: `1px solid`,
                                  borderColor: "divider",
                                  borderRadius: 1.5,
                                  p: 1.25,
                                  bgcolor: "background.paper",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "text.secondary",
                                    mb: 0.5,

                                    letterSpacing: "0.05em",
                                  }}
                                >
                                  Remark
                                </Typography>
                                {returnItem?.remarks ||
                                returnItem?.remarks ||
                                item.returnItem?.remarks ? (
                                  <Box sx={{}}>
                                    {returnItem?.remarks ||
                                      returnItem?.remarks ||
                                      item.returnItem?.remarks}
                                  </Box>
                                ) : (
                                  <Typography sx={{ fontSize: "13px" }}>
                                    -
                                  </Typography>
                                )}
                              </Grid>

                              {/* Attachments */}
                              <Grid
                                item
                                size={{ xs: 12, sm: 4, md: 4 }}
                                sx={{
                                  border: `1px solid`,
                                  borderColor: "divider",
                                  borderRadius: 1.5,
                                  p: 1.25,
                                  bgcolor: "background.paper",
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: "11px",
                                    color: "text.secondary",
                                    mb: 0.5,

                                    letterSpacing: "0.05em",
                                  }}
                                >
                                  Attachments
                                </Typography>
                                <Box>{renderAttachments()}</Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <ImagePopUp
        open={imagePreviewOpen}
        handleClose={() => setImagePreviewOpen(false)}
        image={selectedImage?.url}
        name={selectedImage?.name}
        description={selectedImage?.description}
      />
    </>
  );
};

export default ViewDataReturnsummaryDetails;
